import z from "zod";
import { mapErrorsToFields } from "../../../../utils";
import PhysicalAndMentalSymptomService from "../../../../services/PhysicalAndMentalSymptomService";

const api = new PhysicalAndMentalSymptomService();
export type State = {
  errors?: {
    name?: string[];    
    general?: string[];
  };
  message?: string | null;
  success?: boolean;
  defaultValues?: {
    name?: string;    
  };
};
const FormSchema = z.object({
  name: z.string().min(1, "Name is required."),  
  parentId: z.number().nullable(),
});

export async function addChild(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",    
    parentId: parseInt(formData.get("parentId")?.toString() ?? "0"),
  };
  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Create Symptom.",
      };
    }
    const { name, parentId} = validatedFields.data;
    const result = await api.createSymptom({ name, parentId: parentId ?? undefined });
    if (result.status == 201)
      return {
        message: "Symptom created successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to create symptom.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to create symptom.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}
export async function updateChild(
    id: number,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",    
    parentId: parseInt(formData.get("parentId")?.toString() ?? "0"),
  };  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Update Symptom.",
      };
    }
    const { name, parentId } = validatedFields.data;
    const result = await api.updateSymptom({ id, name, parentId: parentId ?? undefined });
    if (result.status == 204)
      return {
        message: "Symptom updated successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to update symptom.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to update symptom.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}

export async function deleteChild(id: number, prevState: State) {
  try {
    await api.deleteSymptom(id);
    return {
      message: "Symptom deleted successfully.",
      success: true,
    };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to delete symptom.",
      success: false,
    };
  }
}

